export { entity_get_metadata } from '../../systemCommands/entitySystem/entity_get_metadata';
